/**************************************************
 * Nombre:       Detalle_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Producto_Imangenes from "./SubComponentes/Producto_Imangenes";
import Producto_Detalles from "./SubComponentes/Hooks/Producto_Detalles";
import Producto_Especificaciones from "./SubComponentes/Producto_Especificaciones";
import fondo from '../../../Recursos/fondo_especificaciones.svg'
import Detalle_Relacionados from "./Detalle_Relacionados";
import Home_Articulos from "./Home_Articulos";
import {useEffect, useState} from "react";
import {useParams} from "react-router";
import {obtenerDoc} from "../../../Servicios/BD/obtenerDoc";

const Detalle_Producto = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={6}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Producto_Imangenes item={item}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Producto_Detalles item={item}/>
                        </Grid>


                    </Grid>
                </Grid>


            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{
                      justifyContent: 'center',
                      mt: 2,
                      backgroundImage: `url(${fondo})`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                  }}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{maxWidth: '1400px', px: 3}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'center', mt: 12, mb: 12}}>
                        <Producto_Especificaciones item={item}/>
                    </Grid>

                </Grid>
            </Grid>



        </Grid>
    )

}
export default Detalle_Producto